import { Locale } from 'types/Locale'

/**
 * Creates a currency formatter.
 *
 */
export const integerCurrencyFormatter = (locale: Locale) =>
  new Intl.NumberFormat(locale + '-CH', {
    style: 'currency',
    currency: 'CHF',
    minimumFractionDigits: 0
  }).format

/**
 * Return a formatter for percentage values.
 * @param locale
 * @param minimumFractionDigits
 */
export const percentFormatter = (
  locale: Locale,
  minimumFractionDigits: number = 1
) =>
  new Intl.NumberFormat(locale + '-CH', {
    style: 'percent',
    minimumFractionDigits
  }).format

export const integerFormatter = (locale: Locale) =>
  new Intl.NumberFormat(locale + '-CH', {
    maximumFractionDigits: 0
  }).format
